import Excel from "exceljs";
import moment from "moment/moment";

function toExcelDateNumber(value) {
  if (!value) return null;
  const m = moment(value);
  if (!m.isValid()) return null;
  return Math.floor(
    (Date.UTC(m.year(), m.month(), m.date()) - Date.UTC(1899, 11, 30)) /
      86400000,
  );
}

export default async function exportLinesXlsx(planName, lines) {
  const workbook = new Excel.Workbook();
  const sheet = workbook.addWorksheet("Plan Products");
  const lastColumn = 7;
  const lastRow = lines.length + 1;

  sheet.columns = [
    { header: "Product", key: "product", width: 92 },
    { header: "QTY / CTN", key: "qtyPerCarton", width: 20 },
    { header: "QTY", key: "qty", width: 15 },
    { header: "Total CTN", key: "totalCartons", width: 15 },
    { header: "G.W.", key: "grossWeight", width: 15 },
    { header: "CBM", key: "cbm", width: 15 },
    { header: "Ready Date", key: "readyDate", width: 20 },
  ];
  sheet.views = [{ state: "frozen", ySplit: 1 }];

  lines.forEach((line) => {
    const qty = Number(line.finalQty ?? line.qty ?? 0);
    const qtyPerCarton = Number(line?.product?.itemsPerSet ?? 0);
    const totalCartons =
      line.totalCartons !== null && line.totalCartons !== undefined
        ? Number(line.totalCartons)
        : qtyPerCarton > 0
          ? qty / qtyPerCarton
          : 0;

    sheet.addRow({
      product: `[${line.product.number}] (${line.product.countryCodeOfOrigin}) ${line.product.name}${line.product.version ? ` (v${line.product.version})` : ""}`,
      qtyPerCarton,
      qty,
      totalCartons,
      grossWeight: Number(line.totalGrossWeight ?? 0),
      cbm: Number(line.totalCbm ?? 0),
      readyDate: toExcelDateNumber(line.readyDate),
    });
  });

  sheet.getColumn(2).numFmt = "#,##0";
  sheet.getColumn(3).numFmt = "#,##0";
  sheet.getColumn(4).numFmt = "#,##0.###";
  sheet.getColumn(5).numFmt = "#,##0.###";
  sheet.getColumn(6).numFmt = "#,##0.###";
  sheet.getColumn(7).numFmt = "mmm d, yyyy";

  sheet.eachRow((row, rowNumber) => {
    row.height = rowNumber === 1 ? 24 : 22;

    for (let column = 1; column <= 7; column++) {
      row.getCell(column).alignment = {
        ...(row.getCell(column).alignment || {}),
        vertical: "middle",
      };
      row.getCell(column).border = {
        top: { style: "thin", color: { argb: "FFE5E7EB" } },
        left: { style: "thin", color: { argb: "FFE5E7EB" } },
        bottom: { style: "thin", color: { argb: "FFE5E7EB" } },
        right: { style: "thin", color: { argb: "FFE5E7EB" } },
      };
    }

    if (rowNumber === 1) {
      for (let column = 1; column <= 7; column++) {
        row.getCell(column).font = {
          ...(row.getCell(column).font || {}),
          bold: true,
        };
      }
    }

    for (let column = 2; column <= 7; column++) {
      row.getCell(column).alignment = {
        ...(row.getCell(column).alignment || {}),
        horizontal: "right",
      };
    }

    row.getCell(1).alignment = {
      ...(row.getCell(1).alignment || {}),
      horizontal: "left",
      wrapText: true,
    };

    if (rowNumber === 1) {
      row.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F5F7" },
        };
      });
    } else if (rowNumber % 2 === 0) {
      row.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFBFBFD" },
        };
      });
    }
  });

  for (let column = 1; column <= lastColumn; column++) {
    const cell = sheet.getCell(1, column);
    cell.border = {
      ...cell.border,
      bottom: { style: "medium", color: { argb: "FFD1D5DB" } },
    };
  }

  if (lastRow >= 2) {
    for (let column = 1; column <= lastColumn; column++) {
      const cell = sheet.getCell(lastRow, column);
      cell.border = {
        ...cell.border,
        bottom: { style: "medium", color: { argb: "FFD1D5DB" } },
      };
    }
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${planName} - ${lines.length} Products.xlsx`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
